import React, { useState, useEffect, useContext } from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useHistory } from "react-router-dom";
import {
  Backdrop,
  Checkbox,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import * as Sentry from "@sentry/react";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import RefreshIcon from "@material-ui/icons/Refresh";
import { CoinContext } from "../../contexts/CoinContext";
import { REACT_APP_PROD_URL } from "../../services/configs";
import loaderGif from "../../assets/img/loader.gif";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";

var getIfsc = require("ifsc");

const useStyles = makeStyles((theme) => ({
  // container: {
  //   flexGrow: 1,
  //   [theme.breakpoints.down("sm")]: {
  //     minWidth: "450px",
  //     maxWidth: "450px",
  //   },
  // },
  root: {
    // marginTop: theme.spacing(10),
    // marginLeft: theme.spacing(10),
    // alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      // width: '90%',
      marginTop: "20px",
      maxWidth: "500px",
      // minWidth: "450px",
      // marginLeft: "25px",
      // marginRight: "25px",
    },
    [theme.breakpoints.up("md")]: {
      // width: "50%",
      marginTop: "50px",
    },
    // margin: "auto",
    marginBottom: "80px",
  },
  paddedContainer: {
    padding: "40px",
    background: theme.palette.type === "dark" ? "#151827" : "white",
    // for loading screen
    position: "relative",
    zIndex: 0,
  },
  topHeading: {
    color: "#3AC4AB",
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.3rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "2rem",
    },
  },
  table: {
    backgroundColor: theme.palette.type === "dark" ? "#151828" : "white",
    color: theme.palette.text.primary,
    borderBottom: "none",
  },
  tableHeadText: {
    color: theme.palette.text.primary,
    opacity: 0.7,
    fontWeight: "bold",
    borderBottom:
      theme.palette.type === "dark" ? `1px solid #2D2F3E` : `1px solid #B1B1B1`,
  },
  bodyTextStyles: {
    color: theme.palette.text.primary,
    fontSize: "14px",
    borderBottom: "none",
  },
  centeredImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  indifferentCell: {
    borderBottom: "none",
  },
  tableHeading: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    fontSize: "1rem",
    borderBottom:
      theme.palette.type === "dark" ? `1px solid #2D2F3E` : `1px solid #B1B1B1`,
  },
  bodyRows: {
    borderBottom:
      theme.palette.type === "dark" ? `1px solid #2D2F3E` : `1px solid #B1B1B1`,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    color: "#fff",
    fontWeight: "600",
    width: "150px",
  },
  link: {
    fontWeight: "bold",
    color: theme.palette.primary.text,
    paddingLeft: "10px",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    position: "absolute",
  },
}));

// function createData(srno, name, branchName, ifsc, accNo, action) {
//   return { srno, name, branchName, ifsc, accNo, action };
// }

// const rows = [
//   createData(
//     1,
//     "Frozen yoghurt",
//     "HDFC",
//     24,
//     4.0,
//     'Remove'
//   ),
// ];

export default function Bank() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  // const [rows, setRows] = useState([]);
  const [accountNo, setAccountNo] = useState(null);
  const [reaccountNo, setReaccountNo] = useState(null);
  const [isPass, setIsPass] = useState(false);
  const [accNoValid, setAccNoValid] = useState(true);
  const [name, setName] = useState(null);
  const [ifsc, setIfsc] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [bankName, setBankName] = useState(null);
  const [existingBank, setExistingBank] = useState(null);
  const [checked, setChecked] = useState(false);
  const [updateAcc, setUpdateAcc] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [errorFields, setErrorFields] = useState({
    accno: false,
    name: false,
    ifsc: false,
  });

  const [doubleClick, setDoubleClick] = useState(false);

  const { handleClickAlert } = useContext(CoinContext);

  const token = useSelector((state) => state.trading.TOKEN);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getBankDetails();
  }, []);
  const getBankDetails = () => {
    setLoading(true);

    if (token) {
      fetcher(`/v1/um/bankAccount`)
        .then((data) => {
          setExistingBank(data);
          setLoading(false);
          // console.log(data);
        })
        .catch((err) => {
          if (err.status == 500) {
            setExistingBank(false);
          }
          setLoading(false);

          console.error(err);
          // console.error(err);
        });

      // console.log("Getting account details");
    }
  };

  useEffect(() => {
    if (ifsc) {
      if (ifsc.length === 11) {
        if (getIfsc.validate(ifsc)) {
          getIfsc.fetchDetails(ifsc).then(function (res) {
            setBankName(`${res.BANK}, ${res.BRANCH}`);
            setErrorFields({
              ...errorFields,
              ifsc: false,
            });
            // console.log(res);
          });
          // console.log("Getting isfc details");
        } else {
          setBankName(`Not found`);
          setErrorFields({
            ...errorFields,
            ifsc: true,
          });
        }
      }
    } else if (ifsc === "") {
      setBankName(null);
    }
  }, [ifsc]);
  // ifsc as dependency is required.

  function submitForm() {
    if (token && ifsc && accountNo && name) {
      if (ifsc.length === 11) {
        // console.log("Adding account details");

        // console.log(existingBank);

        fetcher(`/v1/um/bankAccount`, {
          method: updateAcc ? "PUT" : "POST",
          body: updateAcc
            ? { ...existingBank }
            : {
                ifsc: ifsc.split(/\s/).join(""),
                accountNo: String(accountNo).split(/\s/).join(""),
                name: name,
              },
        })
          .then((res) => {
            if (updateAcc) {
              setUpdateAcc(false);
            }
            setTimeout(() => {
              getBankDetails();
            }, 1000);
            setIfsc(null);
            setAccountNo(null);
            setReaccountNo(null);
            setName(null);

            setDoubleClick(false);
          })
          .catch((err) => {
            setDoubleClick(false);
            if (err.status === 400) {
              handleClickAlert("error", "This bank account is already in use.");
            } else {
              handleClickAlert("error", "Request failed");
            }
            console.error(err);
            // console.error(err);
          });
      } else {
        // handleClickAlert("error", "Please enter valid IFSC");
        setErrorFields({
          ...errorFields,
          ifsc: true,
        });
        setDoubleClick(false);
      }
    } else {
      setErrorFields({
        accno: accountNo ? false : true,
        name: name ? false : true,
        ifsc: ifsc ? false : true,
      });
      setDoubleClick(false);
    }
  }

  // console.log("double click", doubleClick)

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        // console.log("Yo you pressed enter");
        if (existingBank !== false) {
          if (existingBank !== null && updateAcc === false) {
            if (existingBank.failedAttempts >= 3) {
              // alert("Attempts over, contact support.");
              handleClickOpen();
            } else {
              // console.log("Show edit form");
              setAccountNo(existingBank.accountNumber);
              setReaccountNo(null);
              setName(existingBank.name);
              setIfsc(existingBank.ifsc);
              setUpdateAcc(true);
            }
          } else if (checked) {
            // console.log("Submit form");
            submitForm();
          }
        }
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [existingBank, updateAcc, checked]);
  return (
    <div className={classes.root}>
      <p className={classes.topHeading}>Bank Account</p>

      {existingBank === false ? (
        <Grid container className={classes.paddedContainer}>
          <p>Loading...</p>
        </Grid>
      ) : (
        <Grid container className={classes.paddedContainer}>
          {existingBank && !updateAcc ? (
            <Grid item xs={12} sm={6}>
              <Typography
                style={{
                  marginBottom: "5px",
                  fontSize: "30px",
                  fontWeight: "bold",
                }}
              >
                Bank Info
              </Typography>

              <div style={{ display: "flex", alignItems: "center" }}>
                <p>
                  Bank Account Status is:
                  <span
                    style={{
                      background:
                        theme.palette.type === "dark"
                          ? existingBank.status === "verified" ||
                            existingBank.status === "1"
                            ? "#20581f"
                            : "#581f1f"
                          : existingBank.status === "verified" ||
                            existingBank.status === "1"
                          ? "#C1F4D8"
                          : "#fed9d9",
                      width: "115px",
                      fontWeight: "bold",
                      color:
                        theme.palette.type === "dark"
                          ? existingBank.status === "verified" ||
                            existingBank.status === "1"
                            ? "#C1F4D8"
                            : "#fed9d9"
                          : existingBank.status === "verified" ||
                            existingBank.status === "1"
                          ? "#37a609"
                          : "#ff5f5f",
                      marginLeft: "5px",
                      padding: "4px",
                    }}
                  >
                    {existingBank.status === "verified"
                      ? existingBank.status.toUpperCase()
                      : `${existingBank.status} (${existingBank.failedReason})`}
                  </span>
                </p>
                <Tooltip title="Refresh">
                  <IconButton
                    onClick={() => {
                      getBankDetails();
                    }}
                  >
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>

              {existingBank.status === "verified" ? null : (
                <p>
                  Number of attempts left: {3 - existingBank.failedAttempts}
                </p>
              )}

              <p
                style={{
                  color: "#868786",
                  marginBottom: "0px",
                  fontWeight: "bold",
                  marginTop: "25px",
                }}
              >
                ACCOUNT NUMBER
              </p>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="accountno"
                name="accountno"
                className={classes.textFieldStyles}
                value={existingBank.accountNumber}
                style={{ pointerEvents: "none", opacity: "0.4" }}
              />
              <p
                style={{
                  color: "#868786",
                  marginBottom: "0px",
                  fontWeight: "bold",
                  marginTop: "20px",
                }}
              >
                BANK ACCOUNT HOLDER'S NAME
              </p>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="name"
                name="name"
                className={classes.textFieldStyles}
                value={existingBank.name}
                style={{ pointerEvents: "none", opacity: "0.4" }}
              />
              <p
                style={{
                  color: "#868786",
                  marginBottom: "0px",
                  fontWeight: "bold",
                  marginTop: "20px",
                }}
              >
                IFSC CODE
              </p>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="ifsc"
                name="ifsc"
                className={classes.textFieldStyles}
                value={existingBank.ifsc}
                style={{ pointerEvents: "none", opacity: "0.4" }}
              />

              {existingBank.status === "verified" ||
              existingBank.status === "pending" ? null : (
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={() => {
                    if (existingBank.failedAttempts >= 3) {
                      // alert("Attempts over, contact support.");
                      handleClickOpen();
                    } else {
                      setAccountNo(existingBank.accountNumber);
                      setReaccountNo(null);
                      setName(existingBank.name);
                      setIfsc(existingBank.ifsc);
                      setUpdateAcc(true);
                    }
                  }}
                >
                  Edit
                </Button>
              )}
            </Grid>
          ) : (
            <Grid item xs={12} sm={6}>
              <Typography
                style={{
                  marginBottom: "5px",
                  fontSize: "30px",
                  fontWeight: "bold",
                }}
              >
                Add Bank Info
              </Typography>

              <p
                style={{
                  color: "#868786",
                  marginBottom: "0px",
                  fontWeight: "bold",
                  marginTop: "25px",
                }}
              >
                ACCOUNT NUMBER
              </p>
              <TextField
                variant="outlined"
                required
                fullWidth
                disabled={doubleClick ? true : false}
                id="accountno"
                name="accountno"
                onClick={() => setIsPass(false)}
                InputProps={{
                  classes: { root: classes.textFieldStyles },
                  inputProps: { maxLength: 20 },
                }}
                value={accountNo}
                onChange={(e) => {
                  let val = e.target.value.replace(/[^0-9]/, "");

                  if (updateAcc) {
                    setAccountNo(val);
                    setExistingBank({
                      ...existingBank,
                      accountNumber: String(val).split(/\s/).join(""),
                    });
                  } else {
                    setAccountNo(val);
                  }
                }}
                error={errorFields.accno}
                helperText={
                  errorFields.accno ? "Please enter account number" : null
                }
                type={isPass ? "password" : "text"}
                onKeyDown={(event) => {
                  if (event.key === "Tab") {
                    setIsPass(true);
                  }
                }}
              />

              <p
                style={{
                  color: "#868786",
                  marginBottom: "0px",
                  fontWeight: "bold",
                  marginTop: "25px",
                }}
              >
                RE-ENTER ACCOUNT NUMBER
              </p>
              <TextField
                variant="outlined"
                required
                fullWidth
                disabled={doubleClick ? true : false}
                id="reaccountno"
                name="reaccountno"
                onClick={() => setIsPass(true)}
                value={reaccountNo}
                InputProps={{
                  classes: { root: classes.textFieldStyles },
                  inputProps: { maxLength: 20 },
                }}
                onChange={(e) => {
                  let val = e.target.value.replace(/[^0-9]/, "");
                  setReaccountNo(val);
                  if (val !== accountNo) {
                    setAccNoValid(false);
                  } else {
                    setAccNoValid(true);
                  }
                }}
                onPaste={(e) => {
                  e.preventDefault();
                }}
                error={accNoValid ? false : true}
                helperText={
                  accNoValid ? false : "Account number does not match"
                }
              />
              {/* {accNoValid ? null : (
              <p style={{ color: "red" }}>Account number does not match</p>
            )} */}
              <p
                style={{
                  color: "#868786",
                  marginBottom: "0px",
                  fontWeight: "bold",
                  marginTop: "20px",
                }}
              >
                BANK ACCOUNT HOLDER'S NAME (Exactly as on account)
              </p>
              <TextField
                variant="outlined"
                required
                fullWidth
                disabled={doubleClick ? true : false}
                id="name"
                name="name"
                InputProps={{
                  classes: { root: classes.textFieldStyles },
                }}
                value={name}
                onChange={(e) => {
                  let val = e.target.value.replace(/[^a-zA-Z\s]/, "");
                  if (updateAcc) {
                    setName(val);
                    setExistingBank({
                      ...existingBank,
                      name: val,
                    });
                  } else {
                    setName(val);
                  }
                }}
                error={errorFields.name}
                helperText={errorFields.name ? "Please enter name" : null}
              />

              <p
                style={{
                  color: "#868786",
                  marginBottom: "0px",
                  fontWeight: "bold",
                  marginTop: "20px",
                }}
              >
                IFSC CODE
              </p>
              <TextField
                variant="outlined"
                required
                fullWidth
                disabled={doubleClick ? true : false}
                id="ifsc"
                name="ifsc"
                InputProps={{
                  classes: { root: classes.textFieldStyles },
                  inputProps: { maxLength: 11 },
                }}
                value={ifsc}
                onChange={(e) => {
                  let val = e.target.value.replace(/[^a-zA-Z\d]/, "");
                  if (updateAcc) {
                    setIfsc(val);
                    setExistingBank({
                      ...existingBank,
                      ifsc: val,
                    });
                  } else {
                    setIfsc(val);
                  }
                }}
                error={errorFields.ifsc}
                helperText={errorFields.ifsc ? "Please enter valid IFSC" : null}
              />
              {bankName ? <p>Bank Name: {bankName}</p> : null}

              <div style={{ display: "flex", marginTop: "26px" }}>
                <Checkbox
                  checked={checked}
                  onChange={(event) => {
                    setChecked(event.target.checked);
                  }}
                  color="primary"
                  inputProps={{ "aria-label": "primary checkbox" }}
                  style={{
                    padding: 0,
                    margin: 0,
                    marginRight: "10px",
                    height: "26px",
                  }}
                />
                <p>
                  I confirm that the bank account added is my personal account
                  and will be used for all INR Deposits/Withdrawals on
                  PocketBits.
                </p>
              </div>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() => {
                  setDoubleClick(true);
                  submitForm();
                }}
                // disabled={doubleClick}
                disabled={
                  !doubleClick && accNoValid && checked && !errorFields.ifsc
                    ? false
                    : true
                }
              >
                {updateAcc ? "Update" : "Save"}
              </Button>

              {updateAcc ? (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    if (updateAcc) {
                      setUpdateAcc(false);
                    }
                    // setRefresh(!refresh);
                    setIfsc(null);
                    setAccountNo(null);
                    setReaccountNo(null);
                    setName(null);
                  }}
                  style={{
                    marginTop: "8px",
                    marginLeft: "30px",
                    fontSize: "14px",
                  }}
                >
                  Cancel
                </Button>
              ) : null}
            </Grid>
          )}
          <Backdrop open={loading}>
            {/* <CircularProgress color="primary" /> */}
            <img src={loaderGif} alt="loading..." />
          </Backdrop>
        </Grid>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"You exceeded the number of attempts! Kindly Contact Support."}
        </DialogTitle>
        {/* <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending
            anonymous location data to Google, even when no apps are running.
          </DialogContentText>
        </DialogContent> */}
        <DialogActions style={{ paddingRight: "15px", paddingBottom: "15px" }}>
          <Button onClick={handleClose} color="primary" variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleClose}
            color="primary"
            variant="contained"
            autoFocus
            style={{ fontWeight: "bold", color: "white" }}
          >
            Contact Support
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
